import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DetailsHeader from '../components/DetailsHeader';

// 1. Import Firestore db and query functions
import { db } from '../firebase';
import { collection, query, where, getDocs } from "firebase/firestore";

function SearchPage() {
  const [mdroNo, setMdroNo] = useState('');
  const navigate = useNavigate();
  
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!mdroNo.trim()) return;

    setIsLoading(true);
    setError(null);

    try {
      const q = query(collection(db, "applications"), where("mdroNo", "==", mdroNo.trim()));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        setError("Application not found. Please check the number and try again.");
        setIsLoading(false);
      } else {
        setIsLoading(false);
        navigate(`/application/${mdroNo.trim()}`);
      }
    } catch (err) {
      console.error("Error searching for application: ", err);
      setError("An error occurred. Please try again.");
      setIsLoading(false);
    }
  };

  return (
    <div className="relative flex h-screen min-h-screen w-full flex-col">
      <DetailsHeader />
      
      <main className="flex flex-1 items-center justify-center p-4">
        {/* === CHANGED ===
          Removed 'bg-page-bg/90' and 'shadow-xl' from this div.
          Kept padding for spacing.
        */}
        <div className="w-full max-w-lg rounded-xl p-6 md:p-8">
          <div className="mb-8 text-center">
            {/* === CHANGED ===
              Changed text from 'text-header-text' to 'text-white'
              Added 'drop-shadow-md' for readability.
            */}
            <h2 className="text-3xl font-bold text-white drop-shadow-md">
              Find MDRO Application Details
            </h2>
          </div>
          
          <form onSubmit={handleSearch} className="space-y-6">
            <div className="flex flex-col gap-2">
              {/* === CHANGED ===
                Changed text from 'text-text-color' to 'text-white'
                Made font bold and added 'drop-shadow-md' for readability.
              */}
              <label className="text-base font-bold text-white drop-shadow-md" htmlFor="mdro-no">
                MDRO No
              </label>
              <input
                className="form-input w-full rounded-lg border border-border-color bg-input-bg p-3 text-text-color placeholder-gray-400 focus:border-primary focus:ring-1 focus:ring-primary"
                id="mdro-no"
                placeholder="Enter MDRO Number"
                type="text"
                value={mdroNo}
                onChange={(e) => setMdroNo(e.target.value)}
              />
            </div>
            
            {/* === CHANGED ===
              Added a background to the error message for readability.
            */}
            {error && (
              <div className="rounded-lg bg-white/90 p-3 text-center font-medium text-red-600">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={isLoading} 
              className="w-full rounded-lg bg-primary px-5 py-3 text-base font-bold text-white transition-colors hover:bg-primary-hover focus:outline-none focus:ring-2 focus:ring-primary-hover focus:ring-offset-2 focus:ring-offset-page-bg disabled:opacity-50"
            >
              {isLoading ? 'Searching...' : 'View Details'}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}

export default SearchPage;
